"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _grid = require("@jsluna/grid");

var _link = require("@jsluna/link");

var _form = require("@jsluna/form");

var _AddressSearchBox = _interopRequireDefault(require("./components/AddressSearchBox"));

var _AddressForm = _interopRequireDefault(require("./components/AddressForm"));

var _Modal = _interopRequireDefault(require("./components/Modal/Modal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable prettier/prettier */


var AddressCheckerForm = function AddressCheckerForm(props) {
  var getAddressData = props.getAddressData,
      checkValidation = props.checkValidation,
      showValidationErrors = props.showValidationErrors,
      clearValidationErrors = props.clearValidationErrors,
      isAddressNotGivenChecked = props.isAddressNotGivenChecked,
      showNoAddressError = props.showNoAddressError,
      clearNoAddressError = props.clearNoAddressError;

  var _useState = (0, _react.useState)(null),
      address = _useState[0],
      setAddress = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      manualAddressEntry = _useState2[0],
      setManualAddressEntry = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      showModal = _useState3[0],
      setShowModal = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      checkBoxTicked = _useState5[0],
      setCheckBoxTicked = _useState5[1];

  getAddressData(address); // object: returns the data entered

  checkValidation(isValid); // boolean: returns true if the form is valid

  isAddressNotGivenChecked(checkBoxTicked); // boolean: returns true if Address not given checkbox is ticked

  var setSelectedAddress = function setSelectedAddress(selectedAddress) {
    var addressDetails = {
      businessName: selectedAddress != null && selectedAddress.businessName ? selectedAddress == null ? void 0 : selectedAddress.businessName : '',
      buildingName: selectedAddress != null && selectedAddress.buildingName ? selectedAddress == null ? void 0 : selectedAddress.buildingName : '',
      buildingNumber: selectedAddress == null ? void 0 : selectedAddress.buildingNumber,
      flatNumber: selectedAddress != null && selectedAddress.flatNumber ? selectedAddress == null ? void 0 : selectedAddress.flatNumber : '',
      addressLine1: selectedAddress == null ? void 0 : selectedAddress.street,
      city: selectedAddress == null ? void 0 : selectedAddress.town,
      postcode: selectedAddress == null ? void 0 : selectedAddress.postCode
    };
    setAddress(addressDetails);
  };

  (0, _react.useEffect)(function () {
    var _address$buildingName, _address$buildingNumb, _address$addressLine, _address$city, _address$postCode;

    var postcodeRegEx = /(?:[A-Za-z]\d ?\d[A-Za-z]{2})|(?:[A-Za-z][A-Za-z\d]\d ?\d[A-Za-z]{2})|(?:[A-Za-z]{2}\d{2} ?\d[A-Za-z]{2})|(?:[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]{2})|(?:[A-Za-z]{2}\d[A-Za-z] ?\d[A-Za-z]{2})/;
    setIsValid(checkBoxTicked || !manualAddressEntry && address !== null || manualAddressEntry && ((address == null ? void 0 : (_address$buildingName = address.buildingName) == null ? void 0 : _address$buildingName.length) > 0 || (address == null ? void 0 : (_address$buildingNumb = address.buildingNumber) == null ? void 0 : _address$buildingNumb.length) > 0) && (address == null ? void 0 : (_address$addressLine = address.addressLine1) == null ? void 0 : _address$addressLine.length) > 0 && (address == null ? void 0 : (_address$city = address.city) == null ? void 0 : _address$city.length) > 0 && ((address == null ? void 0 : (_address$postCode = address.postCode) == null ? void 0 : _address$postCode.length) === 0 || postcodeRegEx.test(address == null ? void 0 : address.postcode) || (address == null ? void 0 : address.postCode) === undefined));
  }, [address, checkBoxTicked, manualAddressEntry]);
  (0, _react.useEffect)(function () {
    if (checkBoxTicked === true) {
      setAddress('Address not given');
    } else {
      setAddress(null);
    }
  }, [checkBoxTicked]);
  (0, _react.useEffect)(function () {
    if (manualAddressEntry === true) {
      setCheckBoxTicked(false);
    }
  }, [manualAddressEntry]);

  var handleAddManualAddressClick = function handleAddManualAddressClick() {
    setManualAddressEntry(true);
    clearValidationErrors(false);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    isOpen: showModal,
    handleClose: function handleClose() {
      return setShowModal(false);
    }
  }), (address === null || address === 'Address not given') && manualAddressEntry === false ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, {
    className: "ln-u-flush"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    className: "ln-u-hard-left ln-u-padding-sides*2"
  }, /*#__PURE__*/_react.default.createElement(_AddressSearchBox.default, {
    setAddress: setAddress,
    showValidationErrors: showValidationErrors,
    hasError: !isValid && address === null,
    setSelectedAddress: setSelectedAddress,
    showNoAddressError: showNoAddressError,
    clearNoAddressError: clearNoAddressError
  }), /*#__PURE__*/_react.default.createElement(_link.Link, {
    onClick: function onClick() {
      return handleAddManualAddressClick();
    }
  }, "Or, add an address manually"), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-checkbox-wrapper ln-u-margin-top"
  }, /*#__PURE__*/_react.default.createElement(_form.Checkbox, {
    name: "address-not-given-check-box",
    label: "Address not given",
    defaultChecked: checkBoxTicked,
    onChange: function onChange() {
      return setCheckBoxTicked(!checkBoxTicked);
    }
  }), /*#__PURE__*/_react.default.createElement(_link.Link, {
    className: "c-checkbox-link",
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, "(when to use)"))))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-margin-sides*2"
  }, /*#__PURE__*/_react.default.createElement(_AddressForm.default, {
    address: address,
    setAddress: setAddress,
    manualAddressEntry: manualAddressEntry,
    setManualAddressEntry: setManualAddressEntry,
    showValidationErrors: showValidationErrors,
    hasErrors: !isValid,
    clearValidationErrors: clearValidationErrors
  })));
};

AddressCheckerForm.propTypes = {
  /** 
   * Returns the address object, or string of "Address not given" if the checkbox is selected
  */
  getAddressData: _propTypes.PropTypes.func,

  /** 
   * Returns a boolean value if the form is valid or invalid
   */
  checkValidation: _propTypes.PropTypes.func,

  /** 
   * Pass true if you want to see error messages display over invalid fields
   */
  showValidationErrors: _propTypes.PropTypes.bool,

  /**
   * Pass a function that clears the validation errors when clicking the add address manually link
   */
  clearValidationErrors: _propTypes.PropTypes.func.isRequired,

  /**
   * Pass a function that sets whether the Address not give checkbox is ticked
   */
  isAddressNotGivenChecked: _propTypes.PropTypes.func.isRequired,

  /**
   * A boolean value that determines whether to display a no address added error
   */
  showNoAddressError: _propTypes.PropTypes.bool.isRequired,

  /**
   *  Pass a function that clears the no address error when clicking the save button
   */
  clearNoAddressError: _propTypes.PropTypes.func.isRequired
};
AddressCheckerForm.defaultProps = {
  getAddressData: function getAddressData() {},
  checkValidation: function checkValidation() {},
  showValidationErrors: false
};
var _default = AddressCheckerForm;
exports.default = _default;